export const BRANCHNAME = "develop";export const GITSHASHORT = "6eac64ff";export const GITSHALONG = "6eac64fffc9cc12ee502aa003af9b97ba33ffe47";